var _path, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.461 6.826a2 2 0 0 1 2-2h1.77l1.303-1.262A2 2 0 0 1 8.925 3h2.15a2 2 0 0 1 1.391.564l1.303 1.262h1.77a2 2 0 0 1 2 2V15a2 2 0 0 1-2 2H4.46a2 2 0 0 1-2-2V6.826Z",
    stroke: "#666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.1,
    cy: 7.278,
    rx: 1.131,
    ry: 1.167,
    fill: "#666"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 10.778,
    rx: 3.015,
    ry: 3.111,
    stroke: "#666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCamera;